/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{height:100%;width:100%}.main-container[_ngcontent-%COMP%]{height:calc(100% - 28px);overflow:auto}.toolbar-container[_ngcontent-%COMP%]{background:#dedede;height:33px}.container[_ngcontent-%COMP%], .editor-container[_ngcontent-%COMP%], .ui-inputtext[_ngcontent-%COMP%]{height:100%}  .fr-wrapper{height:calc(100% - 85px);min-height:85px}  .fr-element{height:100%}  .ui-autocomplete-input{width:calc(100% - 25px)}.ui-lg-4[_ngcontent-%COMP%], .ui-lg-8[_ngcontent-%COMP%]{padding:2px}.fieldset[_ngcontent-%COMP%]{width:100%}"];
export { styles as styles };
